import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import { toast } from "react-toastify";
import config from "../function/config";

export default function ResetPassword() {
  const { uidb64, token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async () => {
    if (!newPassword) {
      toast.error("Enter a new password");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${config.base_url}/api/HappyMarineShipping/reset-password/${uidb64}/${token}/`, {
        new_password: newPassword,
      });
      if (res.data.status === 200) {
        toast.success("Password reset successful! Please login.");
        navigate("/login");
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error("Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="bg-white shadow-lg p-6 rounded-lg w-96">
        <h2 className="text-xl font-semibold text-center">Reset Password</h2>
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full border rounded-lg p-2 mt-4"
        />

        
        <button
          onClick={handleReset}
          disabled={loading}
          className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg"
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </div>
    </div>
  );
}
